import { instrumentBatchTypeSchema } from "@station/contracts";
import { Alert } from "@station/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape } from "../../../features/accounting/company.js";
import { todayIstanbul } from "../../../features/accounting/shared.js";
import { BatchWizard } from "../../../features/instruments/batch-wizard.js";
import {
  InstrumentPage,
  useInstrumentCrumb,
  useInstrumentPermissions,
} from "../../../features/instruments/shared.js";

const searchSchema = z.object({
  ...companySearchShape,
  /** Portföyden / çek detayından gelindiğinde tür ve seçili çekler hazır gelir. */
  type: instrumentBatchTypeSchema.optional().catch(undefined),
  ids: z
    .string()
    .regex(/^[0-9a-f-]{36}(,[0-9a-f-]{36}){0,199}$/i)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/_app/cek-senet/bordro-yeni")({
  validateSearch: (search) => searchSchema.parse(search),
  component: NewBatchPage,
});

function NewBatchPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const search = Route.useSearch();
  const crumb = useInstrumentCrumb("/cek-senet/bordrolar");
  const canChange = useInstrumentPermissions().canChange;
  return (
    <InstrumentPage
      title={t("menu.instrumentNewBatch")}
      description={t("instruments.wizard.description")}
      breadcrumb={[crumb, { label: t("menu.instrumentNewBatch") }]}
    >
      {({ companyId }) =>
        canChange ? (
          <BatchWizard
            // Arama parametresi değişince (ör. portföyden yeni seçimle gelindiğinde) sihirbaz baştan kurulur.
            key={`${search.type ?? ""}|${search.ids ?? ""}`}
            companyId={companyId}
            initialType={search.type ?? null}
            initialIds={search.ids ? search.ids.split(",") : []}
            today={todayIstanbul()}
            onCreated={(batchId) =>
              void navigate({ to: "/cek-senet/bordrolar/$id", params: { id: batchId } })
            }
          />
        ) : (
          <Alert tone="warning">{t("instruments.wizard.noPermission")}</Alert>
        )
      }
    </InstrumentPage>
  );
}
